import OrganizationHeader from './OrganizationHeader';

export default OrganizationHeader;
